import { IPlan } from "~/types/billing";
import { IAccount } from "~/types/account";

const SEO_LABEL_REPLACEMENTS: ReadonlyArray<[string, string]> = [
  ["SEO Optimized Product Descriptions per month", "SEO Descriptions"],
  ["SEO Optimized Descriptions per month", "SEO Descriptions"],
  ["SEO Optimized Descriptions", "SEO Descriptions"],
];

export const formatPlanFeatureLabel = (feature: string): string =>
  SEO_LABEL_REPLACEMENTS.reduce(
    (label, [from, to]) => label.replaceAll(from, to),
    feature
  );

export const formatPlanForDisplay = (plan: IPlan): IPlan => ({
  ...plan,
  features: plan.features.map(formatPlanFeatureLabel),
});

export const formatAccountPlanFeatures = (account: IAccount): IAccount => ({
  ...account,
  active_subscription: account.active_subscription
    ? {
        ...account.active_subscription,
        plan: formatPlanForDisplay(account.active_subscription.plan),
      }
    : account.active_subscription,
  last_subscription: account.last_subscription
    ? {
        ...account.last_subscription,
        plan: formatPlanForDisplay(account.last_subscription.plan),
      }
    : account.last_subscription,
});
